// src/pages/ReportsPage.js
import React, { useState, useEffect, useCallback } from 'react'
import { Clock, TrendingUp, DollarSign, Users, RefreshCw, ChevronDown, ChevronUp, Lightbulb, Smartphone } from 'lucide-react'
import { collection, query, orderBy, limit, getDocs, where, doc, updateDoc } from 'firebase/firestore'
import { db } from '../firebaseConfig' // Sesuaikan path ini dengan struktur folder Anda
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, ResponsiveContainer,
  PieChart, Pie, Cell, Legend // ✨ [PERBAIKAN] Tambahkan Legend
} from 'recharts'

// ✨ BARU: Import file halaman performa yang baru dibuat
import PartnerPerformancePage from './PartnerPerformancePage'

export default function ReportsPage() {
  const [activeTab, setActiveTab] = useState('jam_online')

  // ✨ [PERBAIKAN] State baru untuk mengatur Buka/Tutup ke-4 kotak saran
  const [showSaranFunnel, setShowSaranFunnel] = useState(false)
  const [showSaranSpesifik, setShowSaranSpesifik] = useState(false)
  const [showSaranKategori, setShowSaranKategori] = useState(false)
  const [showSaranUser, setShowSaranUser] = useState(false)

  // ✨ [BARU] State untuk Filter Tanggal
  const [dateRange, setDateRange] = useState('7_hari')
  // ✨ [BARU] State untuk Filter Kota
  const [selectedCity, setSelectedCity] = useState('Semua Kota')

  // Data State untuk Tab Jam Online & Filter
  const [sessions, setSessions] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchMitra, setSearchMitra] = useState('') // Filter Nama
  const [sessionSort, setSessionSort] = useState('terbaru') // terbaru, terlama_durasi
  const [sessionDateRange, setSessionDateRange] = useState('30_hari') // 1_hari, 7_hari, 30_hari

  // Data State untuk Tab Analitik Pelanggan
  const [activities, setActivities] = useState([])
  const [loadingActivities, setLoadingActivities] = useState(false)

  // ✨ [BARU] Data State khusus untuk Tabel Log Navigasi User
  const [userLogs, setUserLogs] = useState([])
  const [loadingLogs, setLoadingLogs] = useState(false)

  // ✨ [BARU] Data State untuk Tab Versi Aplikasi
  const [versionsData, setVersionsData] = useState([])
  const [loadingVersions, setLoadingVersions] = useState(false)
  const [versionRoleFilter, setVersionRoleFilter] = useState('Semua') // Semua, Therapist, Cleaner
  const [searchVersionMitra, setSearchVersionMitra] = useState('')

  // ✨ [BARU] Fungsi Download Laporan CSV
  const downloadCSV = (dataList, fileName) => {
    if (dataList.length === 0) return alert("Tidak ada data pesanan untuk diunduh");
    const headers = ["Order ID", "Tanggal", "Layanan", "Kota", "Status", "Harga", "Alasan Batal"];
    
    // [PERBAIKAN] Menggunakan titik koma (;) sebagai pemisah untuk Excel region Indonesia
    const csvRows = [headers.join(';')]; 
    
    dataList.forEach(row => {
      const dateStr = row.createdAt ? formatTime(row.createdAt) : '-';
      const kotaMatch = row.address ? row.address.match(/(Kota|Kabupaten)\s+([^,]+)/) : null;
      const kotaLengkap = kotaMatch ? kotaMatch[0] : "Luar Kota/Tidak Diketahui";
      
      // [PERBAIKAN] Membersihkan karakter 'Enter/Baris Baru' dari alasan batal agar tidak merusak baris di Excel
      const safeCancelReason = (row.cancelReason || '-').replace(/(\r\n|\n|\r)/gm, " ");
      
      csvRows.push([
        `"${row.orderId || '-'}"`,
        `"${dateStr}"`, 
        `"${row.serviceName || '-'}"`,
        `"${kotaLengkap}"`,
        `"${row.status || '-'}"`,
        row.price || 0,
        `"${safeCancelReason}"`
      ].join(';')); // Menggabungkan data dengan titik koma
    });
    
    // [PERBAIKAN] Menambahkan BOM (\ufeff) agar Excel mengenali format UTF-8 (karakter khusus tidak rusak)
    const blob = new Blob(['\ufeff' + csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // ✨ [BARU] Fungsi Download Excel Khusus Jam Online
  const downloadSessionExcel = (dataList) => {
    if (dataList.length === 0) return alert("Tidak ada data untuk diunduh");
    const headers = ["Nama Mitra", "ID HP", "Divisi", "Tanggal", "Jam Mulai", "Jam Selesai", "Total Durasi", "Status"];
    const csvRows = ['\ufeff' + headers.join(';')];

    dataList.forEach(s => {
      const tgl = s.startTime ? s.startTime.toDate().toLocaleDateString('id-ID') : '-';
      const mulai = s.startTime ? s.startTime.toDate().toLocaleTimeString('id-ID') : '-';
      const selesai = s.endTime ? s.endTime.toDate().toLocaleTimeString('id-ID') : 'Sedang Aktif';
      
      csvRows.push([
        `"${s.mitraName || '-'}"`,
        `"${s.deviceId || s.phoneId || '-'}"`,
        `"${s.collectionType || '-'}"`,
        `"${tgl}"`,
        `"${mulai}"`,
        `"${selesai}"`,
        `"${formatDuration(s.startTime, s.endTime)}"`,
        `"${s.status === 'online' ? 'AKTIF' : 'OFFLINE'}"`
      ].join(';'));
    });

    const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Laporan_Jam_Online_${sessionDateRange}.csv`;
    a.click();
  };

  // =====================================================
  // FUNGSI TARIK DATA DARI FIRESTORE (Khusus Jam Online)
  const fetchSessions = useCallback(async () => {
    setLoading(true)
    try {
      // Menarik 100 data absensi terakhir, diurutkan dari yang paling baru
      let days = 30;
      if (sessionDateRange === '1_hari') days = 1;
      if (sessionDateRange === '7_hari') days = 7;
      
      const cutoff = new Date();
      cutoff.setDate(cutoff.getDate() - days);

      // Import 'where' harus ada di bagian atas file
      const q = query(
        collection(db, 'mitra_sessions'),
        where('startTime', '>=', cutoff), // ✨ Filter berdasarkan cutoff tanggal
        orderBy('startTime', 'desc')
      )
      const snap = await getDocs(q)
      
      const data = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
      
      setSessions(data)
    } catch (error) {
      console.error("Gagal menarik data sesi:", error)
    } finally {
      setLoading(false)
    }
  }, [sessionDateRange]) // ✨ PERBAIKAN: Masukkan variabel filter waktu

  // =====================================================
  // FUNGSI UBAH STATUS MITRA (Admin Action)
  // =====================================================
  const updateMitraStatus = async (sessionId, newStatus, mitraId, collectionType) => {
    try {
      // 1. Ubah status di tabel Buku Absen (mitra_sessions)
      const sessionRef = doc(db, 'mitra_sessions', sessionId);
      const sessionUpdates = { status: newStatus };
      
      // Jika dimatikan (offline), sekalian catat jam keluarnya agar durasinya berhenti
      if (newStatus === 'offline') {
        sessionUpdates.endTime = new Date();
      }
      await updateDoc(sessionRef, sessionUpdates);

      // 2. TRIGGER APLIKASI HP MITRA AGAR IKUT MATI (Real-time)
      // Pastikan data mitraId dan divisi (therapists/cleaners) tersedia
      if (mitraId && collectionType) {
        const targetCollection = collectionType.toLowerCase();
        const mitraRef = doc(db, targetCollection, mitraId);
        
        // isBookingActive jadi false jika offline, true jika online
        await updateDoc(mitraRef, { 
          isBookingActive: newStatus === 'online' 
        });
      }
      
      // 3. Update tabel di layar Admin
      setSessions(prevSessions => 
        prevSessions.map(session => 
          session.id === sessionId 
            ? { 
                ...session, 
                status: newStatus,
                // Simulasikan jam berhenti di UI tabel
                endTime: newStatus === 'offline' && !session.endTime ? { toDate: () => new Date(), toMillis: () => new Date().getTime() } : session.endTime
              } 
            : session
        )
      );
    } catch (error) {
      console.error("Gagal mengubah status:", error);
      alert("Gagal mengubah status mitra.");
    }
  };

  // =====================================================
  // FUNGSI TARIK DATA DARI FIRESTORE (Analitik Pelanggan / Orders)
  // =====================================================
  const fetchActivities = useCallback(async () => {
    setLoadingActivities(true)
    try {
      let limitDays = 7;
      if (dateRange === '30_hari') limitDays = 30;
      if (dateRange === '90_hari') limitDays = 90;

      const pastDate = new Date();
      pastDate.setDate(pastDate.getDate() - limitDays);

      // KEMBALIKAN KE 'orders' AGAR GRAFIK & EXCEL BERJALAN
      const q = query(
        collection(db, 'orders'),
        orderBy('createdAt', 'desc')
      );
      const snap = await getDocs(q);
      
      const data = [];
      snap.forEach(doc => {
        const docData = doc.data();
        if (docData.createdAt && docData.createdAt.toDate() >= pastDate) {
          data.push({ id: doc.id, ...docData });
        }
      });
      setActivities(data);
    } catch (error) {
      console.error("Gagal menarik data pesanan:", error)
    } finally {
      setLoadingActivities(false)
    }
  }, [dateRange])

  // ✨ [BARU] Fungsi khusus menarik data navigasi user untuk tabel log bawah
  const fetchUserLogs = useCallback(async () => {
    setLoadingLogs(true);
    try {
      let limitDays = 30;
      if (dateRange === '7_hari') limitDays = 7;
      if (dateRange === '90_hari') limitDays = 90;

      const pastDate = new Date();
      pastDate.setDate(pastDate.getDate() - limitDays);

      const q = query(
        collection(db, 'user_activity'),
        where('timestamp', '>=', pastDate),
        orderBy('timestamp', 'desc')
      );
      const snap = await getDocs(q);
      let rawData = [];
      snap.forEach(doc => rawData.push({ id: doc.id, ...doc.data() }));

      const userGroups = {};
      rawData.forEach(log => {
        const userId = log.uid || 'anonim';
        if (!userGroups[userId]) userGroups[userId] = [];
        userGroups[userId].push(log);
      });

      Object.keys(userGroups).forEach(uid => {
        const logs = userGroups[uid];
        for (let i = 0; i < logs.length; i++) {
          logs[i].durasiMs = (i > 0) ? logs[i-1].timestamp.toMillis() - logs[i].timestamp.toMillis() : null;
        }
      });
      setUserLogs(rawData);
    } catch (error) {
      console.error("Gagal menarik data navigasi:", error);
    } finally {
      setLoadingLogs(false);
    }
  }, [dateRange]);

  // ✨ [BARU] Fungsi Tarik Data Versi Aplikasi
  const fetchAppVersions = useCallback(async () => {
    setLoadingVersions(true);
    try {
      // Tarik dari dua tabel sekaligus
      const therapistsSnap = await getDocs(collection(db, 'therapists'));
      const cleanersSnap = await getDocs(collection(db, 'cleaners'));

      let combinedData = [];

      therapistsSnap.forEach(doc => {
        const data = doc.data();
        combinedData.push({
          id: doc.id,
          nama: data.name || data.nama || 'Tanpa Nama',
          mitraId: data.id_number || '-',
          role: 'Therapist',
          app_version: data.app_version || 'Belum Terdeteksi',
          last_login: data.last_login_version ? data.last_login_version.toDate() : null
        });
      });

      cleanersSnap.forEach(doc => {
        const data = doc.data();
        combinedData.push({
          id: doc.id,
          nama: data.name || data.nama || 'Tanpa Nama',
          mitraId: data.id_number || '-',
          role: 'Cleaner',
          app_version: data.app_version || 'Belum Terdeteksi',
          last_login: data.last_login_version ? data.last_login_version.toDate() : null
        });
      });

      // Urutkan dari yang terbaru login
      combinedData.sort((a, b) => (b.last_login?.getTime() || 0) - (a.last_login?.getTime() || 0));

      setVersionsData(combinedData);
    } catch (error) {
      console.error("Gagal menarik data versi:", error);
    } finally {
      setLoadingVersions(false);
    }
  }, []);

  // Tarik data saat pertama kali halaman dibuka ATAU saat rentang tanggal diubah
  useEffect(() => {
    if (activeTab === 'jam_online') {
      fetchSessions()
    } else if (activeTab === 'pelanggan') {
      fetchActivities()
      fetchUserLogs()
    } else if (activeTab === 'versi_aplikasi') {
      fetchAppVersions()
    }
  }, [activeTab, dateRange, sessionDateRange, fetchSessions, fetchActivities, fetchUserLogs, fetchAppVersions])
  // =====================================================
  // HELPER FORMAT WAKTU & DURASI
  // =====================================================
  const formatTime = (timestamp) => {
    if (!timestamp) return '-'
    
    // ✨ [PERBAIKAN] Cek apakah ini Firestore Timestamp atau JS Date biasa
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    
    return date.toLocaleString('id-ID', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    })
  }

  const formatDuration = (start, end) => {
    if (!start) return '-'
    if (!end) return 'Sedang Berjalan...'
    
    const diffMs = end.toMillis() - start.toMillis()
    const diffMins = Math.floor(diffMs / 60000)
    
    if (diffMins < 60) return `${diffMins} Menit`
    const hours = Math.floor(diffMins / 60)
    const mins = diffMins % 60
    return `${hours} Jam ${mins} Menit`
  }

  // 👇 LETAKKAN KODE BARU DI SINI 👇
  const formatDurasi = (ms) => {
    if (ms === null) return 'Sedang Aktif';
    const totalSeconds = Math.floor(ms / 1000);
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return mins > 0 ? `${mins}m ${secs}d` : `${secs} detik`;
  };

  // =====================================================
  // RENDER TAB: BUKU ABSEN / JAM ONLINE
  // =====================================================
  const renderJamOnline = () => {
    // Logika Pencarian & Pengurutan
    let filteredSessions = sessions.filter(s => 
      (s.mitraName || '').toLowerCase().includes(searchMitra.toLowerCase())
    );

    if (sessionSort === 'terlama_durasi') {
      filteredSessions.sort((a, b) => {
        const durA = a.endTime ? (a.endTime.toMillis() - a.startTime.toMillis()) : 0;
        const durB = b.endTime ? (b.endTime.toMillis() - b.startTime.toMillis()) : 0;
        return durB - durA;
      });
    }

    return (
      <div className="bg-gray-800 rounded-lg shadow border border-gray-700 overflow-hidden">
      <div className="p-4 border-b border-gray-700 bg-gray-800/50 space-y-4">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold text-white">Log Aktivitas & Jam Online</h2>
          <button onClick={() => downloadSessionExcel(filteredSessions)} className="bg-green-600 text-white px-3 py-1.5 rounded-lg text-sm hover:bg-green-500 flex items-center gap-2">
            <DollarSign size={14}/> Export Excel
          </button>
        </div>
        
        <div className="flex flex-wrap gap-3">
          <input type="text" placeholder="Cari Nama Mitra..." value={searchMitra} onChange={(e) => setSearchMitra(e.target.value)} className="bg-gray-900 border border-gray-700 rounded-md px-3 py-1.5 text-sm w-48 outline-none focus:border-blue-500" />
          <select value={sessionSort} onChange={(e) => setSessionSort(e.target.value)} className="bg-gray-900 border border-gray-700 rounded-md px-3 py-1.5 text-sm outline-none">
            <option value="terbaru">Urut: Terbaru</option>
            <option value="terlama_durasi">Urut: Durasi Terlama</option>
          </select>
          <select value={sessionDateRange} onChange={(e) => setSessionDateRange(e.target.value)} className="bg-gray-900 border border-gray-700 rounded-md px-3 py-1.5 text-sm outline-none">
            <option value="1_hari">Hari Ini</option>
            <option value="7_hari">7 Hari Terakhir</option>
            <option value="30_hari">30 Hari Terakhir</option>
          </select>
          
          {/* ✨ Tombol Refresh diletakkan sejajar langsung dengan filter */}
          <button 
            onClick={fetchSessions}
            className="flex items-center gap-2 px-3 py-1.5 bg-gray-700 text-blue-400 rounded-lg hover:bg-gray-600 transition text-sm font-medium"
          >
            <RefreshCw size={14} className={loading ? "animate-spin" : ""} />
            Refresh
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm text-gray-300">
          <thead className="bg-gray-900/50 text-gray-400 uppercase font-semibold text-xs">
            <tr>
              <th className="px-4 py-3">Nama Mitra</th>
              <th className="px-4 py-3">ID HP</th>
              <th className="px-4 py-3">Divisi</th>
              <th className="px-4 py-3">Waktu Mulai</th>
              <th className="px-4 py-3">Waktu Selesai</th>
              <th className="px-4 py-3">Total Durasi</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="px-4 py-8 text-center text-gray-500">
                  Memuat data sesi...
                </td>
              </tr>
            ) : filteredSessions.length === 0 ? (
              <tr>
                <td colSpan="7" className="px-4 py-8 text-center text-gray-500">
                  Belum ada catatan aktivitas mitra yang sesuai.
                </td>
              </tr>
            ) : (
              filteredSessions.map(s => (
                <tr key={s.id} className="border-b border-gray-700 hover:bg-gray-700/50 transition">
                  <td className="px-4 py-3 font-medium text-gray-100">{s.mitraName || 'Anonim'}</td>
                  <td className="px-4 py-3 text-xs text-gray-400 font-mono">{s.deviceId || s.phoneId || '-'}</td>
                  <td className="px-4 py-3 capitalize">{s.collectionType || '-'}</td>
                  <td className="px-4 py-3 text-green-400">{formatTime(s.startTime)}</td>
                  <td className="px-4 py-3 text-red-400">{formatTime(s.endTime)}</td>
                  <td className="px-4 py-3 font-medium text-gray-200">{formatDuration(s.startTime, s.endTime)}</td>
                  <td className="px-4 py-3">
                    <select
                      value={s.status === 'online' ? 'online' : 'offline'}
                      // ✨ Tambahkan s.mitraId dan s.collectionType ke dalam pemanggilan fungsi
                      onChange={(e) => updateMitraStatus(s.id, e.target.value, s.mitraId, s.collectionType)}
                      className={`px-2 py-1 rounded outline-none text-xs font-bold cursor-pointer transition ${
                        s.status === 'online' 
                          ? 'bg-green-900/50 text-green-400 border border-green-800' 
                          : 'bg-gray-700 text-gray-400 border border-gray-600'
                      }`}
                    >
                      <option value="online">AKTIF</option>
                      <option value="offline">OFFLINE</option>
                    </select>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}  
  // =====================================================
  // RENDER TAB: PLACEHOLDER KOSONG
  // =====================================================
  const renderPlaceholder = (title, desc) => (
    <div className="bg-gray-800 rounded-lg shadow border border-gray-700 p-12 text-center flex flex-col items-center">
      <div className="w-16 h-16 bg-gray-900 text-blue-400 rounded-full flex items-center justify-center mb-4">
        <TrendingUp size={32} />
      </div>
      <h2 className="text-xl font-bold text-white mb-2">{title}</h2>
      <p className="text-gray-400 max-w-md">
        {desc} Modul analitik ini sedang dalam tahap pengembangan dan akan segera hadir pada pembaruan sistem berikutnya.
      </p>
    </div>
  )

  // =====================================================
  // RENDER TAB: ANALITIK PELANGGAN (Berdasarkan Tabel Orders)
  // =====================================================
  const renderPelanggan = () => {

    // ✨ [PERBAIKAN] LOGIKA EKSTRAKSI & FILTER KOTA
    const citiesSet = new Set();
    const activitiesWithCity = activities.map(act => {
      const kotaMatch = act.address ? act.address.match(/(Kota|Kabupaten)\s+([^,]+)/) : null;
      const kota = kotaMatch ? kotaMatch[0] : "Luar Kota/Tidak Diketahui";
      citiesSet.add(kota);
      return { ...act, extractedCity: kota }; // Tempelkan nama kota ke dalam data
    });

    // Buat daftar unik kota untuk diisi ke Dropdown
    const uniqueCities = Array.from(citiesSet).sort();

    // Terapkan Filter Kota (Jika "Semua Kota", pakai semua data. Jika pilih kota tertentu, saring datanya)
    const filteredActivities = selectedCity === 'Semua Kota' 
      ? activitiesWithCity 
      : activitiesWithCity.filter(act => act.extractedCity === selectedCity);

    // 1. OLAH DATA LAYANAN SPESIFIK & PIE CHART (Menggunakan filteredActivities)
    const serviceCounts = filteredActivities.reduce((acc, curr) => {
      if (curr.serviceName) {
        const name = curr.serviceName.toUpperCase();
        acc[name] = (acc[name] || 0) + 1;
      }
      return acc;
    }, {});

    const popularPagesData = Object.keys(serviceCounts)
      .map(key => ({ name: key, jumlah: serviceCounts[key] }))
      .sort((a, b) => b.jumlah - a.jumlah)
      .slice(0, 5);

    const specificServiceData = Object.keys(serviceCounts)
      .map(key => ({ 
        name: key.replace(/\b\w/g, l => l.toUpperCase()),
        jumlah: serviceCounts[key] 
      }))
      .sort((a, b) => a.jumlah - b.jumlah);

    const COLORS = ['#FF6B6B', '#FEC84E', '#4ECDC4', '#556270', '#C44D58'];

    // 2. OLAH DATA CORONG / STATUS PESANAN (Menggunakan filteredActivities)
    const totalOrders = filteredActivities.length;
    const completedOrders = filteredActivities.filter(a => a.status === 'completed').length;
    const cancelledOrders = filteredActivities.filter(a => a.status === 'cancelled').length;
    const unpaidOrders = filteredActivities.filter(a => a.status === 'unpaid').length;

    const funnelData = [
      { step: '1. Total Pesanan Masuk', pengguna: totalOrders },
      { step: '2. Belum Dibayar', pengguna: unpaidOrders },
      { step: '3. Dibatalkan', pengguna: cancelledOrders },
      { step: '4. Sukses / Selesai', pengguna: completedOrders },
    ];

    // 3. OLAH DATA PERILAKU BACA ALASAN BATAL (Menggunakan filteredActivities)
    const userBehavior = filteredActivities.reduce((acc, curr) => {
      const userName = curr.userName || 'Anonim';
      if (!acc[userName]) {
        acc[userName] = { name: userName, selesai: 0, batalUser: 0, batalSistem: 0 };
      }
      if (curr.status === 'completed') {
        acc[userName].selesai += 1;
      } else if (curr.status === 'cancelled') {
        if (curr.cancelledBy === 'customer') {
          acc[userName].batalUser += 1;
        } else {
          acc[userName].batalSistem += 1;
        }
      }
      return acc;
    }, {});

    const userBehaviorData = Object.values(userBehavior)
      .filter(u => u.selesai > 0 || u.batalUser > 0 || u.batalSistem > 0)
      .sort((a, b) => (b.batalUser + b.batalSistem) - (a.batalUser + a.batalSistem))
      .slice(0, 10);

    return (
      <div className="space-y-6">
        
        {/* ✨ Header Section dengan Filter Waktu, KOTA, & Tombol Download */}
        <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center p-4 bg-gray-800 rounded-lg shadow border border-gray-700 gap-4">
          <div>
            <h2 className="text-lg font-semibold text-white flex items-center gap-2">
              Laporan Pesanan & Perilaku 
              {loadingActivities && <RefreshCw size={14} className="animate-spin text-blue-400" />}
            </h2>
            <p className="text-xs text-gray-400">Total {filteredActivities.length} data di <strong className="text-blue-300">{selectedCity}</strong>.</p>
          </div>
          
          <div className="flex flex-wrap items-center gap-3 w-full xl:w-auto">
            
            {/* ✨ [BARU] Dropdown Filter Kota */}
            <select 
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
              className="bg-gray-900 text-gray-200 text-sm border border-gray-600 rounded-lg px-3 py-2 outline-none cursor-pointer hover:border-blue-400 transition"
            >
              <option value="Semua Kota">📍 Semua Kota</option>
              {uniqueCities.map((city, idx) => (
                <option key={idx} value={city}>{city}</option>
              ))}
            </select>

            <select 
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
              className="bg-gray-900 text-gray-200 text-sm border border-gray-600 rounded-lg px-3 py-2 outline-none cursor-pointer hover:border-blue-400 transition"
            >
              <option value="7_hari">📅 7 Hari Terakhir</option>
              <option value="30_hari">📅 30 Hari Terakhir</option>
              <option value="90_hari">📅 3 Bulan Terakhir</option>
            </select>

            {/* ✨ [PERBAIKAN] Download CSV sekarang mengunduh filteredActivities */}
            <button 
              onClick={() => downloadCSV(filteredActivities, `Laporan_Zimo_${selectedCity}_${dateRange}`)}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-500 text-white rounded-lg transition shadow-md text-sm font-medium"
            >
              <DollarSign size={16} /> Export Excel
            </button>
          </div>
        </div>

        {/* Grafik Section - BARIS 1 (Khusus Grafik Batang Vertikal agar Sejajar) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          
          {/* Chart 1: Funnel Drop-off */}
          <div className="bg-gray-800 p-5 rounded-lg border border-gray-700 shadow flex flex-col">
            <h3 className="text-md font-bold text-white mb-2">Tingkat Retensi (Funnel)</h3>
            <p className="text-xs text-gray-400 mb-6">Melacak perjalanan pelanggan dari awal hingga akhir.</p>
            <div className="w-full flex-1"> {/* 👈 Hapus style minHeight */}
              <ResponsiveContainer width="99%" height={340}>
                <BarChart data={funnelData} layout="vertical" margin={{ top: 10, right: 30, left: 20, bottom: 20 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" horizontal={false} />
                  <XAxis type="number" stroke="#9CA3AF" />
                  <YAxis dataKey="step" type="category" width={145} stroke="#9CA3AF" fontSize={11} />
                  <RechartsTooltip contentStyle={{ backgroundColor: '#1F2937', borderColor: '#374151', color: '#fff' }} />
                  <Bar dataKey="pengguna" fill="#3B82F6" radius={[0, 4, 4, 0]} barSize={24} />
                </BarChart>
              </ResponsiveContainer>
            </div>
            {/* ✨ [PERBAIKAN] Kotak Saran Toggleable (Funnel) */}
            <div className="mt-6 bg-blue-900/10 border border-blue-800/50 rounded-lg overflow-hidden transition-all">
              <button onClick={() => setShowSaranFunnel(!showSaranFunnel)} className="w-full p-3 flex items-center justify-between bg-blue-900/20 hover:bg-blue-900/30 text-blue-300 transition">
                <div className="flex items-center gap-2 font-semibold text-sm">
                  <Lightbulb size={16} className="text-yellow-400" /> 3 Rekomendasi Analitik Retensi
                </div>
                {showSaranFunnel ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>
              {showSaranFunnel && (
                <div className="p-4 space-y-3 text-sm text-gray-300 border-t border-blue-800/30 bg-blue-900/5">
                  <p><strong className="text-blue-400">1. Optimasi Checkout:</strong> Terdapat potensi drop-off. Berikan promo kecil (diskon 10%) di halaman Layanan untuk mendorong user menekan tombol pesan.</p>
                  {/* ✨ [PERBAIKAN] Ubah variabel cancelCount menjadi cancelledOrders */}
                  <p><strong className="text-blue-400">2. Analisis Pembatalan:</strong> Ada <span className="text-white font-bold">{cancelledOrders} pesanan</span> batal. Tambahkan fitur estimasi waktu tiba agar pelanggan tidak membatalkan karena lelah menunggu.</p>
                  <p><strong className="text-blue-400">3. Sederhanakan Beranda:</strong> Jika rasio Buka Beranda ke Lihat Layanan rendah, perbesar ikon layanan Anda agar lebih mencolok.</p>
                </div>
              )}
            </div>
          </div>

          {/* Chart 3: Layanan Spesifik (DIPINDAH KE BARIS 1 AGAR SEJAJAR) */}
          <div className="bg-gray-800 p-5 rounded-lg border border-gray-700 shadow flex flex-col">
            <h3 className="text-md font-bold text-white mb-2">Performa Layanan Spesifik</h3>
            <p className="text-xs text-gray-400 mb-6">Melihat layanan dari yang jarang dipesan hingga paling sering.</p>
            <div className="w-full flex-1">
              <ResponsiveContainer width="99%" height={340}>
                <BarChart data={specificServiceData} layout="vertical" margin={{ top: 10, right: 30, left: 10, bottom: 20 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" horizontal={false} />
                  <XAxis type="number" stroke="#9CA3AF" />
                  <YAxis dataKey="name" type="category" width={180} stroke="#9CA3AF" fontSize={11} />
                  <RechartsTooltip contentStyle={{ backgroundColor: '#1F2937', borderColor: '#374151', color: '#fff' }} />
                  <Bar dataKey="jumlah" fill="#10B981" radius={[0, 4, 4, 0]} barSize={24} />
                </BarChart>
              </ResponsiveContainer>
            </div>
            {/* ✨ [PERBAIKAN] Kotak Saran Toggleable (Layanan Spesifik membaca data Real-time) */}
            <div className="mt-6 bg-green-900/10 border border-green-800/50 rounded-lg overflow-hidden transition-all">
              <button onClick={() => setShowSaranSpesifik(!showSaranSpesifik)} className="w-full p-3 flex items-center justify-between bg-green-900/20 hover:bg-green-900/30 text-green-300 transition">
                <div className="flex items-center gap-2 font-semibold text-sm">
                  <Lightbulb size={16} className="text-yellow-400" /> 3 Rekomendasi Performa Layanan
                </div>
                {showSaranSpesifik ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>
              {showSaranSpesifik && (
                <div className="p-4 space-y-3 text-sm text-gray-300 border-t border-green-800/30 bg-green-900/5">
                  <p><strong className="text-green-400">1. Pemasangan Badge:</strong> Berikan label "Best Seller" pada layanan <span className="text-white font-bold">{specificServiceData.length > 0 ? specificServiceData[specificServiceData.length - 1].name : 'unggulan'}</span> untuk menarik pengguna baru.</p>
                  <p><strong className="text-green-400">2. Evaluasi Layanan:</strong> Layanan <span className="text-white font-bold">{specificServiceData.length > 0 ? specificServiceData[0].name : 'terbawah'}</span> sangat jarang dipesan. Pertimbangkan untuk merevisi harga, mengubah deskripsi, atau menghapusnya.</p>
                  <p><strong className="text-green-400">3. Flash Sale Terbatas:</strong> Adakan diskon jam sepi (Happy Hour) untuk layanan dengan performa menengah agar penjualannya naik kelas.</p>
                </div>
              )}
            </div>
          </div>

        </div>

        {/* Grafik Section - BARIS 2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          
          {/* Chart 2: Layanan Terpopuler (Pie Chart) (DIPINDAH KE BARIS 2) */}
          <div className="bg-gray-800 p-5 rounded-lg border border-gray-700 shadow flex flex-col">
            <h3 className="text-md font-bold text-white mb-2">Layanan Paling Sering Diklik (Kategori)</h3>
            <p className="text-xs text-gray-400 mb-6">Melihat minat utama pelanggan saat ini berdasarkan Kategori.</p>
            <div className="w-full flex-1">
              <ResponsiveContainer width="99%" height={340}>
                <PieChart margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
                  <Pie
                    data={popularPagesData}
                    cx="50%"
                    cy="50%"
                    innerRadius={45}
                    outerRadius={65}
                    paddingAngle={5}
                    dataKey="jumlah"
                    label={({name, percent}) => {
                      const shortName = name.length > 14 ? name.substring(0, 14) + '...' : name;
                      return `${shortName} ${(percent * 100).toFixed(0)}%`;
                    }}
                    labelLine={true}
                    style={{ fontSize: '11px', fontWeight: '600' }}
                  >
                    {popularPagesData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <RechartsTooltip contentStyle={{ backgroundColor: '#1F2937', borderColor: '#374151', color: '#fff', fontSize: '12px' }} />
                </PieChart>
              </ResponsiveContainer>
            </div>
            {/* ✨ [PERBAIKAN] Kotak Saran Toggleable (Kategori Pie Chart) */}
            <div className="mt-6 bg-purple-900/10 border border-purple-800/50 rounded-lg overflow-hidden transition-all">
              <button onClick={() => setShowSaranKategori(!showSaranKategori)} className="w-full p-3 flex items-center justify-between bg-purple-900/20 hover:bg-purple-900/30 text-purple-300 transition">
                <div className="flex items-center gap-2 font-semibold text-sm">
                  <Lightbulb size={16} className="text-yellow-400" /> 3 Rekomendasi Minat Pasar
                </div>
                {showSaranKategori ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>
              {showSaranKategori && (
                <div className="p-4 space-y-3 text-sm text-gray-300 border-t border-purple-800/30 bg-purple-900/5">
                  <p><strong className="text-purple-400">1. Etalase Utama:</strong> Tempatkan kategori <span className="text-white font-bold">{popularPagesData.length > 0 ? popularPagesData[0].name : 'terpopuler'}</span> di urutan paling atas beranda aplikasi karena memegang persentase minat terbesar.</p>
                  <p><strong className="text-purple-400">2. Strategi Bundling:</strong> Buat paket bundling yang menggabungkan kategori terlaris dengan kategori yang paling sepi untuk subsidi silang pendapatan.</p>
                  <p><strong className="text-purple-400">3. Fokus Marketing:</strong> Gunakan visual dari kategori terlaris tersebut jika Anda menjalankan iklan berbayar (Instagram/Facebook Ads).</p>
                </div>
              )}
            </div>
          </div>

          {/* Chart 4: Rasio Penyelesaian & Pembatalan User */}
          <div className="bg-gray-800 p-5 rounded-lg border border-gray-700 shadow flex flex-col">
            <h3 className="text-md font-bold text-white mb-2">Riwayat Batal vs Selesai (Pengguna)</h3>
            <p className="text-xs text-gray-400 mb-6">Menganalisa pengguna dari yang paling sering membatalkan pesanan.</p>
            <div className="w-full flex-1">
              <ResponsiveContainer width="99%" height={340}>
                <BarChart data={userBehaviorData} margin={{ top: 10, right: 30, left: -20, bottom: 25 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" vertical={false} />
                  <XAxis dataKey="name" stroke="#9CA3AF" fontSize={11} interval={0} angle={-25} textAnchor="end" tickFormatter={(val) => val.length > 8 ? val.substring(0,8)+'...' : val} />
                  <YAxis type="number" stroke="#9CA3AF" allowDecimals={false} />
                  <RechartsTooltip contentStyle={{ backgroundColor: '#1F2937', borderColor: '#374151', color: '#fff' }} />
                  <Legend verticalAlign="top" height={36} iconType="circle" wrapperStyle={{ fontSize: '12px' }} />
                  <Bar dataKey="batal" name="Dibatalkan" fill="#EF4444" radius={[4, 4, 0, 0]} barSize={16} />
                  <Bar dataKey="selesai" name="Diselesaikan" fill="#3B82F6" radius={[4, 4, 0, 0]} barSize={16} />
                </BarChart>
              </ResponsiveContainer>
            </div>
            {/* ✨ [PERBAIKAN] Kotak Saran Toggleable (Perilaku User) */}
            <div className="mt-6 bg-red-900/10 border border-red-800/50 rounded-lg overflow-hidden transition-all">
              <button onClick={() => setShowSaranUser(!showSaranUser)} className="w-full p-3 flex items-center justify-between bg-red-900/20 hover:bg-red-900/30 text-red-300 transition">
                <div className="flex items-center gap-2 font-semibold text-sm">
                  <Lightbulb size={16} className="text-yellow-400" /> 3 Rekomendasi Manajemen Pelanggan
                </div>
                {showSaranUser ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>
              {showSaranUser && (
                <div className="p-4 space-y-3 text-sm text-gray-300 border-t border-red-800/30 bg-red-900/5">
                  <p><strong className="text-red-400">1. Sistem Suspend Sementara:</strong> Jika terdapat pengguna dengan batas batal merah jauh lebih tinggi dari biru, terapkan blokir otomatis 24 jam untuk mencegah order fiktif.</p>
                  <p><strong className="text-red-400">2. Program VIP:</strong> Deteksi pengguna yang memiliki grafik biru (Selesai) tertinggi tanpa pembatalan, dan berikan mereka voucher rahasia untuk merawat loyalitas.</p>
                  <p><strong className="text-red-400">3. Follow-Up CS:</strong> Jika pelanggan reguler tiba-tiba memiliki grafik merah (batal), minta tim CS menghubungi mereka via WhatsApp untuk menanyakan kendala atau error aplikasi.</p>
                </div>
              )}
            </div>
          </div>

        </div>

        {/* Tabel Log Mentah */}
        <div className="bg-gray-800 rounded-lg border border-gray-700 mt-6">
          <div className="p-4 border-b border-gray-700 bg-gray-800/50">
            <h3 className="text-md font-bold text-white">Log Aktivitas Detail</h3>
          </div>
          <div className="overflow-x-auto max-h-64">
            <table className="w-full text-left text-sm text-gray-300">
              <thead className="bg-gray-900/50 text-gray-400 uppercase font-semibold text-xs sticky top-0">
                <tr>
                  <th className="px-4 py-3">Waktu</th>
                  <th className="px-4 py-3">Nama Pengguna</th>
                  <th className="px-4 py-3">Halaman / Aksi</th>
                  <th className="px-4 py-3">Durasi</th>
                </tr>
              </thead>
              <tbody>
                {loadingLogs ? (
                  <tr>
                    <td colSpan="4" className="px-4 py-8 text-center text-gray-500">
                      Memuat data navigasi pelanggan...
                    </td>
                  </tr>
                ) : userLogs.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="px-4 py-8 text-center text-gray-500">
                      Belum ada catatan navigasi pelanggan.
                    </td>
                  </tr>
                ) : (
                  userLogs.map((act) => (
                    <tr key={act.id} className="border-b border-gray-700 hover:bg-gray-700/50 transition">
                      <td className="px-4 py-2 text-gray-400">
                        {act.timestamp ? formatTime(act.timestamp) : '-'}
                      </td>
                      <td className="px-4 py-2 font-medium text-gray-200">
                        {act.name || 'Anonim'}
                      </td>
                      <td className="px-4 py-2 font-bold">
                        <span className={act.type === 'navigation' ? "text-blue-400" : "text-green-400"}>
                          {act.type === 'navigation' ? `Halaman: ${act.menu}` : `Aksi: ${act.menu}`}
                        </span>
                        {/* 👇 Tambahan agar Order ID atau Jumlah (Val) muncul jika ada */}
                        {(act.orderId || act.amount) && (
                          <div className="text-xs font-normal text-gray-400 mt-1 font-mono">
                            {act.orderId && `ID: ${act.orderId} `} {act.amount && `| Val: ${act.amount}`}
                          </div>
                        )}
                      </td>
                    <td className="px-4 py-2 text-gray-400">
                      {formatDurasi(act.durasiMs)}
                    </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

  // ✨ [BARU] Fungsi Export Excel Khusus Versi Aplikasi
  const exportVersiExcel = async (dataList) => {
    if (dataList.length === 0) return alert("Tidak ada data versi untuk diunduh");
    try {
      const XLSX = await import('xlsx');
      const dataToExport = dataList.map(v => ({
        "Nama Mitra": v.nama || '-',
        "ID Mitra": v.mitraId || '-',
        "Divisi": v.role || '-',
        "Versi Terpasang": v.app_version || 'Belum Terdeteksi',
        "Terakhir Cek/Login": v.last_login ? formatTime(v.last_login) : '-'
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      ws['!cols'] = [{ wch: 25 }, { wch: 20 }, { wch: 15 }, { wch: 18 }, { wch: 25 }];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Versi Aplikasi");
      XLSX.writeFile(wb, `Laporan_Versi_Aplikasi_${new Date().toISOString().split('T')[0]}.xlsx`);
    } catch (error) {
      console.error("Export Excel Error:", error);
      alert("Gagal mengunduh Excel. Pastikan modul xlsx telah terinstal (npm install xlsx).");
    }
  };

  // =====================================================
  // ✨ [BARU] RENDER TAB: VERSI APLIKASI
  // =====================================================
  const renderVersiAplikasi = () => {
    let filteredVersions = versionsData.filter(v => {
      const matchRole = versionRoleFilter === 'Semua' || v.role === versionRoleFilter;
      const matchName = v.nama.toLowerCase().includes(searchVersionMitra.toLowerCase());
      return matchRole && matchName;
    });

    return (
      <div className="bg-gray-800 rounded-lg shadow border border-gray-700 overflow-hidden">
        <div className="p-4 border-b border-gray-700 bg-gray-800/50 space-y-4">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold text-white">Pemantauan Versi Aplikasi Mitra</h2>
          </div>
          <div className="flex flex-wrap gap-3">
            <input 
              type="text" 
              placeholder="Cari Nama Mitra..." 
              value={searchVersionMitra} 
              onChange={(e) => setSearchVersionMitra(e.target.value)} 
              className="bg-gray-900 border border-gray-700 rounded-md px-3 py-1.5 text-sm w-48 outline-none focus:border-blue-500 text-white" 
            />
            <select 
              value={versionRoleFilter} 
              onChange={(e) => setVersionRoleFilter(e.target.value)} 
              className="bg-gray-900 border border-gray-700 rounded-md px-3 py-1.5 text-sm outline-none text-white cursor-pointer"
            >
              <option value="Semua">Semua Divisi</option>
              <option value="Therapist">Therapist</option>
              <option value="Cleaner">Cleaner</option>
            </select>
            <button 
              onClick={fetchAppVersions} 
              className="flex items-center gap-2 px-3 py-1.5 bg-gray-700 text-blue-400 rounded-lg hover:bg-gray-600 transition text-sm font-medium"
            >
              <RefreshCw size={14} className={loadingVersions ? "animate-spin" : ""} /> Refresh
            </button>
            
            {/* ✨ [BARU] Tombol Export Excel diletakkan di sebelah tombol Refresh */}
            <button 
              onClick={() => exportVersiExcel(filteredVersions)}
              className="flex items-center gap-2 px-3 py-1.5 bg-green-600 text-white rounded-lg hover:bg-green-500 transition text-sm font-medium"
            >
              Export Excel
            </button>
          </div>
        </div>

        <div className="overflow-x-auto w-full">
          <table className="w-full text-left text-sm text-gray-300 whitespace-nowrap">
            <thead className="bg-gray-900/50 text-gray-400 uppercase font-semibold text-xs">
              <tr className="border-b border-gray-700">
                <th className="px-6 py-4">Nama Mitra</th>
                <th className="px-6 py-4">ID Mitra</th>
                <th className="px-6 py-4 text-center">Divisi</th>
                <th className="px-6 py-4 text-center">Versi Terpasang</th>
                <th className="px-6 py-4 text-right">Terakhir Cek/Login</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {loadingVersions ? (
                <tr>
                  <td colSpan="5" className="px-6 py-8 text-center text-gray-500">Memuat data versi aplikasi...</td>
                </tr>
              ) : filteredVersions.length === 0 ? (
                <tr>
                  <td colSpan="5" className="px-6 py-8 text-center text-gray-500">Belum ada data versi yang terdeteksi.</td>
                </tr>
              ) : (
                filteredVersions.map(v => (
                  <tr key={v.id} className="hover:bg-gray-700/30 transition">
                    <td className="px-6 py-4 font-medium text-gray-100">{v.nama}</td>
                    <td className="px-6 py-4 text-gray-400 font-mono">{v.mitraId}</td>
                    <td className="px-6 py-4 text-center">
                      <span className={`inline-block px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${
                        v.role === 'Therapist' 
                          ? 'bg-orange-900/30 text-orange-400 border border-orange-800/50' 
                          : 'bg-blue-900/30 text-blue-400 border border-blue-800/50'
                      }`}>
                        {v.role}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      {v.app_version === 'Belum Terdeteksi' ? (
                        <span className="inline-block text-red-400 font-medium text-xs bg-red-900/20 px-3 py-1 rounded-full border border-red-800/30">
                          Belum Terdeteksi
                        </span>
                      ) : (
                        <span className="inline-block text-green-400 font-medium text-xs bg-green-900/20 px-3 py-1 rounded-full border border-green-800/50">
                          {v.app_version}
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4 text-gray-400 text-right">{formatTime(v.last_login)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  // =====================================================
  // UI UTAMA
  // =====================================================
  return (
    <div className="p-6 bg-gray-900 min-h-full text-white">
      {/* HEADER PAGE */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Pusat Laporan & Analitik</h1>
        <p className="text-gray-400 text-sm">Pantau performa, jam kerja, dan metrik sistem Zimo</p>
      </div>

      {/* TAB NAVIGATION */}
      <div className="flex gap-2 overflow-x-auto pb-4 mb-2 border-b border-gray-800">
        <TabButton 
          active={activeTab === 'jam_online'} 
          onClick={() => setActiveTab('jam_online')}
          icon={<Clock size={16} />}
          label="Jam Online Mitra"
        />
        <TabButton 
          active={activeTab === 'performa'} 
          onClick={() => setActiveTab('performa')}
          icon={<TrendingUp size={16} />}
          label="Performa Mitra"
        />
        <TabButton 
          active={activeTab === 'keuangan'} 
          onClick={() => setActiveTab('keuangan')}
          icon={<DollarSign size={16} />}
          label="Transaksi & Pendapatan"
        />
        <TabButton 
          active={activeTab === 'pelanggan'} 
          onClick={() => setActiveTab('pelanggan')}
          icon={<Users size={16} />}
          label="Analitik Pelanggan"
        />
        {/* ✨ TAB BARU: VERSI APLIKASI */}
        <TabButton 
          active={activeTab === 'versi_aplikasi'} 
          onClick={() => setActiveTab('versi_aplikasi')}
          icon={<Smartphone size={16} />}
          label="Versi Aplikasi"
        />
      </div>

      {/* KONTEN BERDASARKAN TAB */}
      <div>
        {activeTab === 'jam_online' && renderJamOnline()}
        {/* ✨ PERBAIKAN: Ganti placeholder dengan memanggil komponen file baru */}
        {activeTab === 'performa' && <PartnerPerformancePage />}
        {activeTab === 'keuangan' && renderPlaceholder('Laporan Transaksi & Keuangan', 'Rekapitulasi pendapatan kotor, komisi aplikasi, dan pergerakan saldo dompet secara menyeluruh.')}
        {activeTab === 'pelanggan' && renderPelanggan()}
        {activeTab === 'versi_aplikasi' && renderVersiAplikasi()}
      </div>
    </div>
  )
}

// Komponen Pembantu untuk Tombol Tab
function TabButton({ active, onClick, icon, label }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm transition-all whitespace-nowrap ${
        active 
          ? 'bg-blue-600 text-white shadow-md' 
          : 'bg-gray-800 text-gray-400 border border-gray-700 hover:bg-gray-700 hover:text-white'
      }`}
    >
      {icon}
      {label}
    </button>
  )
}